import type { MouseEvent } from 'react';
import { formatPublicationTime } from './functions';
import { snapshotCellRectFromEvent } from './calendarCellAnchor';
import { getCalendarPillStyle } from './pillStyles';
import type { CalendarPublication, CalendarPublicationHoverAnchor } from './types';
import nfThumb from '../../assets/nf_thumb.svg';

const PILL_CLASS =
    'w-full truncate text-[11px] font-medium leading-tight rounded-sm p-0.5 hover:opacity-80';

type PublicationPillProps = Readonly<{
    publication: CalendarPublication;
    index: number;
    fillCell?: boolean;
    onHoverStart: (
        publication: CalendarPublication,
        anchor: CalendarPublicationHoverAnchor,
    ) => void;
    onHoverEnd: () => void;
}>;

const PILL_FILL_CELL_CLASS = 'flex-1';
const PILL_TITLE_FILL_CELL_CLASS = 'flex-1 line-clamp-4';

export function PublicationPill({
    publication,
    index,
    fillCell = false,
    onHoverStart,
    onHoverEnd,
}: PublicationPillProps) {
    const handleMouseEnter = (event: MouseEvent<HTMLButtonElement>) => {
        onHoverStart(publication, {
            clientX: event.clientX,
            clientY: event.clientY,
            cellRect: snapshotCellRectFromEvent(event),
        });
    };

    return (
        <button
            type="button"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={onHoverEnd}
            className={`${PILL_CLASS} ${getCalendarPillStyle(index)} flex gap-0.5 ${
                fillCell ? `${PILL_FILL_CELL_CLASS} items-start` : 'items-center'
            }`}
        >
            <span className={fillCell ? PILL_TITLE_FILL_CELL_CLASS : 'truncate'}>
                {formatPublicationTime(publication.publicationDate)} - {publication.title}
            </span>
            {publication.isGlobal && (
                <img src={nfThumb} alt="Global" className="ml-auto h-3 w-3 shrink-0" />
            )}
        </button>
    );
}
